import { useTranslation } from 'react-i18next';

import type { components } from 'wg-api-sdk';

import AISparkles from '@/components/common/AISparkles';

import GeneralAdvice from './GeneralAdvice';

type Props = {
  advice: Maybe<components['schemas']['OnesuranceAdvice']>;
};

export default function OnesuranceAdvice({ advice }: Props) {
  const { t } = useTranslation();

  if (!advice) return null;

  return (
    <div className="flex flex-col gap-2 p-2">
      <p className="text-md flex items-center gap-1.5 text-sm">
        <AISparkles />

        {t('ONESURANCE_RECOMMENDATIONS_ADVICE_TITLE')}
      </p>

      <div key={advice.title} className="flex flex-col gap-2">
        <GeneralAdvice advice={advice} />
      </div>
    </div>
  );
}
